import { Component, OnInit, Input, Inject } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireFunctions } from '@angular/fire/functions';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DetalleCursoCompradoComponent } from '../detalle-curso-comprado/detalle-curso-comprado.component'

interface valoracion {
  comentario: string,
  completado: boolean,
  conocimientos: number,
  fecha: Date,
  global: number,
  instructor: number,
  material: number,
  plataforma: number,
}

@Component({
  selector: 'valorar-curso',
  templateUrl: './valorar-curso.component.html',
  styleUrls: ['./valorar-curso.component.css']
})

export class ValorarCursoComponent implements OnInit {

  loaded: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ValorarCursoComponent>,
    private afs: AngularFirestore,
    private functions: AngularFireFunctions,
    private router: Router,
  ) {
  }
  valoracion = {
    comentario: "",
    completado: false,
    conocimientos: 0,
    fecha: '',
    global: 0,
    instructor: 0,
    material: 0,
    plataforma: 0,
  };

  enviado = 0;
  resultado = false;

  usuario = JSON.parse(localStorage.getItem('user'))

  ngOnInit(): void {
  }

  enviar() {
    this.loaded = 0;
    this.valoracion.completado = this.data.completado;
    this.valoracion.fecha = new Date().toLocaleDateString("es-ES", {hour:'2-digit',minute:'2-digit',day: 'numeric', month:'long', year:'numeric'});
    this.valoracion.global = (this.valoracion.conocimientos
      +this.valoracion.instructor+this.valoracion.material
      +this.valoracion.plataforma)/4;

    this.functions.httpsCallable("valorarCurso")({
      usuarioPhotoURL: this.usuario.photoURL,
      usuarioNombreCompleto: this.usuario.nombreCompleto,
      cursoId: this.data.id,
      valoracion: this.valoracion,
    }).toPromise().then(() => {
      this.enviado = 2;
      this.resultado = true;
      this.dialogRef.beforeClosed().subscribe(() => {
        this.dialogRef.close(true)
      })
    }).catch((error) => {
      console.log(error);
    })
  }
}
